import * as React from 'react';
import { useQuery, Direction } from './Query';
import { FilterHeader } from './QueryTable';
import Modal, { ModalSize } from '../misc/components/modal';
import Select from 'react-select';

export interface Option {
    label: any;
    value: any
}

interface StatusHeaderProps {
    title?: string;
    orderField: string;
    overreadStatuses: Option[];
    analysisSetTypeValue?: string;
    sortField?: string;
    automationId?: string;
}

export const StatusHeader = ({ title, orderField, overreadStatuses, analysisSetTypeValue, sortField = null, automationId = null }: StatusHeaderProps) => {

    const [display, setDisplay] = React.useState(false);
    const { filters, ordering, applyOrdering } = useQuery();
    const [ordered, setOrdered] = React.useState<Direction>();
    const [filtered, setFiltered] = React.useState(false);
    sortField = sortField ?? orderField;
    title = title ?? "Status";

    React.useEffect(() => {
        const filtered = filters.some(f => (f.field === 'analysisSets' && f.condition === 'any' && f.subQueryConditions?.find(sqc => sqc.value === analysisSetTypeValue)));
        setFiltered(filtered);
    }, [filters]);

    React.useEffect(() => {

        const ordered = ordering.find(o => o.field === sortField);
        setOrdered(ordered
            ? ordered.condition
            : null);
    }, [ordering]);

    const handleSort = () => {
        let direction: Direction = 'asc';

        if (ordered === 'asc')
            direction = 'desc';

        applyOrdering([{ field: sortField, condition: direction }]);
    }

    const handleFilter = () => {
        setDisplay(true);
    }

    const modal = display
        ? (
            <StatusFilterModal
                overreadStatuses={overreadStatuses}
                analysisSetTypeValue={analysisSetTypeValue}
                onClose={() => setDisplay(false)} />
        )
        : null;

    return (
        <>
            <FilterHeader automationId={automationId} filtered={filtered} sorted={ordered} onFilter={handleFilter} onSort={handleSort}>{title}</FilterHeader>
            {modal}
        </>
    );
}

interface StatusFilterModalProps {
    overreadStatuses: any[];
    analysisSetTypeValue?: string;
    onClose: () => void;
}

export const StatusFilterModal = ({ overreadStatuses, onClose, analysisSetTypeValue }: StatusFilterModalProps) => {

    const [statusValues, setStatusValues] = React.useState<any[]>([]);

    const { filters, applyFilters, paging, applyPaging } = useQuery();

    const analysisSetsField = 'analysisSets'
        , analysisSetsSubField = 'status'
        , analysisSetTypeField = 'type'
        , analysisSetType = analysisSetTypeValue ?? 'SAS_OVERREAD';

    React.useEffect(() => {
        const currentStatusValues = filters
            .filter(f => f.field === analysisSetsField && f.condition === 'any' && f.subQueryConditions?.find(sqc => sqc.value === analysisSetTypeValue))
            .flatMap(f => f.values);

        setStatusValues(currentStatusValues);
    }, [filters]);


    const handleApply = () => {
        let newFilters = filters.filter(f => !(f.field == analysisSetsField && f.subQueryConditions?.find(sqc => sqc.value === analysisSetTypeValue)));

        statusValues && statusValues.length > 0 && (
            newFilters = [...newFilters,
            {
                field: analysisSetsField,
                condition: 'any',
                primarySubClauseField: analysisSetsSubField,
                primarySubQueryCondition: 'eq',
                values: statusValues,
                subQueryConditions: [
                    {
                        subClauseField: analysisSetTypeField,
                        subCondition: 'eq',
                        value: analysisSetType
                    },
                ]
            }
            ]);

        applyPaging({ ...paging, page: 1 });
        applyFilters(newFilters);
        onClose();
    }

    const handleClear = () => {
        applyPaging({ ...paging, page: 1 });

        applyFilters(filters.filter(
            f =>
                (
                    f.field !== analysisSetsField
                )
        ));

        onClose();
    }

    return (
        <Modal header={`Status Filter`} size={ModalSize.Normal} show={true} closeModalHandler={onClose}>
            <div className="modal-body">
                <label>Status</label>
                <Select
                    id="overread-status-match"
                    name="match1"
                    isMulti={true}
                    classNamePrefix="multiSelect"
                    options={overreadStatuses}
                    autoFocus={true}
                    value={statusValues.map(v => overreadStatuses.find(o => o.value === v))}
                    getOptionLabel={o => o.label}
                    getOptionValue={o => o.value}
                    onChange={(o: any[]) => setStatusValues(o.map(v => v.value))}
                />
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={handleApply} data-automationid="submit-filter">OK</button>
                <button className="btn btn-danger" onClick={handleClear} data-automationid="clear-filter">Clear</button>
            </div>
        </Modal>
    );
};
